export default "__VITE_ASSET__CmMxcmmR__"